'use client';
import { Conditional, useBreakpoint } from '@cat-ecom/pcc-components';
import { Image } from 'components/image';
import { PAGE_BREAKPOINTS } from 'constants/common';
import {
  CatHeading,
  CatCard,
  CatIconChevronRight
} from 'components/blocks-components';
import styles from './shop-category-card.module.scss';
import { IMAGE_ALT_LABLE } from '../../../_constants/constants';

type ShopCategoryCardProps = {
  title: string;
  imageUrl: string;
};

export const ShopCategoryCard = ({
  title,
  imageUrl
}: Readonly<ShopCategoryCardProps>) => {
  const isDesktop = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  return (
    <CatCard removePadding variant="bare">
      <div
        className={`${styles['shop-category-card']} d-flex align-items-center gap-3 p-2`}
      >
        <Image
          src={imageUrl}
          width={75}
          height={75}
          loading="lazy"
          alt={`${IMAGE_ALT_LABLE} ${title}`}
          className={styles['shop-category-card__image']}
        />
        <CatHeading
          className={styles['shop-category-card__title']}
          variant="label-lg"
        >
          {title}
        </CatHeading>

        <Conditional test={!isDesktop}>
          <CatIconChevronRight
            data-testid={`cat-icon-chevron-right-${title}`}
            className={`ms-auto u-color--Black`}
          />
        </Conditional>
      </div>
    </CatCard>
  );
};
